import { mainApi } from "services/main";
import {
  SearchPendingReassessmentLinesRequest,
  SearchPendingReassessmentLinesResponse,
  RegisterManualFXRatesRequest,
  RegisterManualFXRatesResponse,
} from "./interfaces";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    searchPendingReassessmentLines: builder.query<
      SearchPendingReassessmentLinesResponse,
      SearchPendingReassessmentLinesRequest
    >({
      query: (params) => ({
        url: "reassessment/manual/search_pending_reassessment_lines",
        method: "POST",
        body: params,
      }),
    }),
    registerManualFXRates: builder.mutation<
      RegisterManualFXRatesResponse,
      RegisterManualFXRatesRequest
    >({
      query: (params) => ({
        url: "reassessment/manual/register_fx_rates",
        method: "POST",
        body: params,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useSearchPendingReassessmentLinesQuery,
  useRegisterManualFXRatesMutation,
} = extendedApi;
